export default function ConditionalWrapper({ condition, children, wrapper }) {
  return condition ? wrapper(children) : children
}
